'use client';

import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface PillProps {
  children: ReactNode;
  className?: string;
  showDot?: boolean;
  dotColor?: string;
  variant?: 'default' | 'left';
}

export function Pill({
  children,
  className,
  showDot = true,
  dotColor = 'text-gray-800 dark:text-gray-100',
  variant = 'default',
}: PillProps) {
  const isLeftVariant = variant === 'left';

  return (
    <p
      className={cn(
        'relative inline-flex items-center justify-center py-3 text-[12px] font-semibold tracking-[0.14em] uppercase text-gray-800 dark:text-gray-100 bg-transparent',
        isLeftVariant ? 'pl-0 pr-5' : 'px-5',
        className
      )}
    >
      <span
        className={cn(
          "absolute inset-x-0 bottom-0 h-px",
          isLeftVariant
            ? "bg-gradient-to-r from-gray-300 to-transparent dark:from-gray-600"
            : "bg-gradient-to-r from-transparent via-gray-300 to-transparent dark:via-gray-600"
        )}
        aria-hidden="true"
      />
      {showDot && (
        <span
          className={cn(
            'absolute -bottom-[8px] text-[12px] text-primary-500 dark:text-primary-500 drop-shadow-sm',
            isLeftVariant
              ? 'left-0'
              : 'left-1/2 -translate-x-1/2',
            dotColor
          )}
          aria-hidden="true"
        >
          ✦
        </span>
      )}
      {children}
    </p>
  );
}

